<div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
  <!-- Header Section -->
  <div class="text-center mb-5">
        <img src="assets/brand/{{
        layoutService.colorScheme() === 'light'
          ? 'logo-light'
          : 'logo-dark'
      }}.png" alt="Sequal App Logo" height="50" class="mb-3" />
    <div class="text-900 text-3xl font-medium mb-3">
      Recover Password
    </div>
    <span class="text-600 font-medium line-height-3">Remember your password?</span>
    <a (click)="navigateToLogin()" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Sign in</a>
  </div>

  <!-- Recovery Form -->
  <form [formGroup]="recoveryForm" (ngSubmit)="onSubmit()">
    <!-- Email Field -->
    <div class="mb-3">
      <label for="email" class="block text-900 font-medium mb-2">Email</label>
      <input id="email" type="email" placeholder="Email address" pInputText formControlName="email"
        class="w-full mb-3" />
      @if (
        recoveryForm.get('email')?.invalid && recoveryForm.get('email')?.touched
        ) {
        <small class="p-error">
          Invalid email
        </small>
      }
    </div>

    <!-- Captcha -->
    @if (isCaptchaRequired()) {
      <div class="mb-3 sm:mb-4">
        <app-captcha />
      </div>
    }

    <!-- Submit Button -->
    <button pButton pRipple label="Recover Password" icon="pi pi-envelope" class="w-full"
    [disabled]="recoveryForm.invalid || isSubmitting()" [loading]="isSubmitting()"></button>

    <!-- Success Message -->
    @if (recoverySuccess()) {
      <p class="success-message mt-3">
        Recovery email sent successfully!
      </p>
    }
  </form>
</div>